import { PendingAntrag, FreigabeAuftrag, LetzterKontakt, PendingDokument } from '../../portal/ApiClient';

export type SpaltenId =
  | 'radar' | 'neu' | 'in_pruefung' | 'freigabe_geplant'
  | 'behoerde' | 'zuverlaessig' | 'abgewiesen' | 'abgelaufen';

export interface SpalteDef {
  id: SpaltenId;
  titel: string;
  farbe: string;   // Bootstrap-Variant für den Spaltenkopf
  leer: string;    // Text wenn Spalte leer
  hinweis?: string;
}

// Reihenfolge links -> rechts. Am Handy von oben nach unten.
export const SPALTEN: SpalteDef[] = [
  { id: 'radar', titel: '📡 Radar', farbe: 'secondary',
    leer: 'Niemand in den nächsten 90 Tagen fällig.',
    hinweis: 'ZÜP läuft bald ab, noch kein Vorgang.' },
  { id: 'neu', titel: '📥 Neu', farbe: 'primary',
    leer: 'Keine neuen Einreichungen.' },
  { id: 'in_pruefung', titel: '🔄 In Bearbeitung bei Behörde', farbe: 'warning',
    leer: 'Nichts in Bearbeitung.',
    hinweis: 'Anträge in unserer Prüfung UND freigegebene Fälle. Die Karte zeigt, ob der Fall noch auf die Flughafen-Übernahme wartet oder schon beim BMIMI liegt — erst ab Übernahme laufen die 28 Tage.' },
  { id: 'freigabe_geplant', titel: '⏱️ Freigabe eingeplant', farbe: 'info',
    leer: 'Keine Freigabe eingeplant.',
    hinweis: 'Wird automatisch im nächsten Behörden-Fenster übermittelt — kein Handeln nötig.' },
  { id: 'zuverlaessig', titel: '✅ Zuverlässig', farbe: 'success',
    leer: 'Nichts in den letzten 7 Tagen abgeschlossen.' },
  { id: 'abgewiesen', titel: '⟂ Abgewiesen (FZT)', farbe: 'danger',
    leer: 'Nichts abgewiesen.' },
  { id: 'abgelaufen', titel: '🕳 Abgelaufen', farbe: 'dark',
    leer: 'Keine abgelaufenen Zuverlässigkeiten.',
    hinweis: 'Crosscheck: ZÜP abgelaufen, kein laufender Vorgang. Grau = gewollt (NV), rot = ungeplant.' },
];

export type Quelle = 'antrag' | 'auftrag' | 'behoerde' | 'radar' | 'fertig' | 'abgelaufen' | 'dokument';

export interface BoardCard {
  key: string;            // stabil & eindeutig
  spalte: SpaltenId;
  name: string;
  mgdNummer?: string | null;
  pId?: number | string | null;
  quelle: Quelle;
  art?: string;           // ART_LABEL-Key oder 'einklick'
  datum?: string | null;  // spaltenspezifisch (ISO)
  datumLabel?: string;    // z.B. 'läuft ab', 'übermittelt', 'angelegt'
  ampel?: string;         // radar
  vorgang?: string;       // radar
  telefon?: string;
  brauchtSr?: boolean;    // radar: Auslands-Wohnsitz -> Strafregister nötig
  srLaender?: string[];
  resttage?: number | null;   // behoerde
  deadline?: string | null;   // behoerde
  behoerdenStatus?: string;   // behoerde
  eFrist?: string | null;     // behoerde / zuverlaessig ("zuverlässig bis")
  note?: string | null;       // fehler-Auftrag
  einklick?: boolean;         // Auftrag ohne verknüpften Antrag
  fehler?: boolean;
  wartetAdmin?: boolean;
  nv?: boolean;               // abgelaufen: gewollt (persnummer '-NV')
  neuantrag?: boolean;        // abgelaufen: Portal-Erstantrag, Person hatte nie eine ZÜP
  emailVorhanden?: boolean;   // abgelaufen: Aufforderung per Mail möglich?
  letzteAufforderung?: string | null; // abgelaufen: jüngster Versand
  letzterKontakt?: LetzterKontakt | null; // abgelaufen: jüngste Kontaktaufnahme
  // Original-Objekte für die Aktions-Buttons (genau EINES gesetzt + optional antrag):
  antrag?: PendingAntrag;
  auftrag?: FreigabeAuftrag;
  dokument?: PendingDokument;
}

// Labels = UNSER Bearbeitungsstand (nicht die Behörden-Entscheidung).
export const ART_LABEL: Record<string, string> = {
  verlaengerung: 'ZÜP-Verlängerung',
  erstantrag: 'Erstantrag (Komplett)',
  ausweis: 'Ausweis-Verlängerung',
  bg_wechsel: 'BG-Wechsel (Übernahme)',
  einklick: 'Ein-Klick-Verlängerung',
};
// Vokabular (siehe reference_zuep_vokabular): übermitteln (Datensatz ins USP,
// evtl. unvollständig) != freigeben (freigabe_e, zur Prüfung ausgelöst).
export const STATUS_LABEL: Record<string, string> = {
  neu: 'Neu', in_pruefung: 'In Prüfung', freigabe_geplant: 'Freigabe eingeplant',
  importiert: 'An Behörde übermittelt', freigegeben: 'Zur Prüfung freigegeben', abgelehnt: 'Abgewiesen (FZT)',
};
export const STATUS_BADGE: Record<string, string> = {
  neu: 'primary', in_pruefung: 'warning', freigabe_geplant: 'info',
  importiert: 'info', freigegeben: 'success', abgelehnt: 'danger',
};
